import React from 'react';
import { Box } from '@mui/material';
import ReactMarkdown from 'react-markdown';
import { aiSourceHref, aiSourceDate, readableAiText } from './aiExplanationText';
export default function AiExplanation({ text, sources = [], locale = 'tr' }) {
  const links = new Map(sources.map(source => [aiSourceHref(source), source]).filter(([href]) => href));
  return <Box sx={{ fontSize: '0.9rem', lineHeight: 1.75, overflowWrap: 'anywhere',
    '& h2, & h3, & h4': { fontSize: '1rem', fontWeight: 700, mt: 2.5, mb: 0.75, lineHeight: 1.4 },
    '& > :first-of-type': { mt: 0 }, '& p': { mt: 0, mb: 1.5 }, '& ul, & ol': { pl: 2.5, mt: 0.5, mb: 1.5 },
    '& li': { mb: 0.75 }, '& li > p': { mb: 0 },
    '& a': { color: 'primary.main', fontSize: '0.8rem', textDecoration: 'none', borderBottom: '1px dotted', whiteSpace: 'normal' },
  }}><ReactMarkdown skipHtml components={{ img: () => null, a: ({ href, children }) => {
    const source = links.get(href);
    return source ? <a href={href} title={aiSourceDate(source, locale)}>{children}</a> : <span>{children}</span>;
  } }}>{readableAiText(text, sources, locale)}</ReactMarkdown></Box>;
}
